export interface EndFreeSpinsPopupParams {
  closeOnAnimFinished?: boolean;
  closeButtonsName?: string;
  isMoneyResult?: boolean;
  totalWinTextId?: string;
  totalLoseTextId?: string;
  spinsWinTextId?: string;
  spinsLoseTextId?: string;
  animSceneId?: string;
  winStateName?: string;
  loseStateName?: string;
  winCloseStateName?: string;
  loseCloseStateName?: string;
  autoCloseTimeout?: number;
  stopBackgroundSound?: boolean;
  useFreeSpinMode?: boolean;
  useViewUpdater?: boolean;
  animateTotalWin?: boolean;
  animateTotalWinDelay?: number;
  animateTotalWinDuration?: number;
}

export const END_FREE_SPINS_DEFAULT_PARAMS: EndFreeSpinsPopupParams = {
  closeButtonsName: 'back_to_game',
  totalWinTextId: 'total_win_text',
  totalLoseTextId: 'total_lose_text',
  spinsWinTextId: 'spins_win_text',
  spinsLoseTextId: 'spins_lose_text',
  animSceneId: 'page',
  winStateName: 'win',
  loseStateName: 'lose',
  winCloseStateName: 'winClose',
  loseCloseStateName: 'loseClose',
  autoCloseTimeout: 5.0,
};
